<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header titleIcon="lock"
    title="Compliance Locks"
    subtitle="Regulatory minimums a tenant's rule pack cannot go below. Every lock must cite the regulation it comes from."
  />

  <app-entity-catalog
    [catalog]="catalogView"
    [records]="records"
    [loading]="loading"
    [saving]="saving"
    [error]="error"
    [hideTitle]="true"
    [canCreate]="view === 'active'"
    [canEdit]="view === 'active'"
    [canDelete]="view === 'active'"
    [canRestore]="view === 'deleted'"
    [toolbarTabs]="toolbarTabs"
    [activeToolbarTab]="activeToolbarTab"
    [searchPlaceholder]="'Search country, parameter, regulation…'"
    (toolbarTabChange)="onToolbarTabChange($event)"
    (save)="onSave($event)"
    (delete)="onDelete($event)"
    (restore)="onRestore($event)"
  />
</div>

<app-delete-confirm-modal
  [open]="showDeleteModal"
  heading="Delete compliance lock?"
  [entityName]="deleteEntityName"
  entityNoun="compliance lock"
  message="This will remove the regulatory floor from the list. The record is kept for audit but will no longer enforce limits."
  confirmLabel="Delete"
  loadingLabel="Deleting…"
  [loading]="deleteLoading()"
  [error]="deleteError"
  variant="permanent"
  (cancelled)="closeDeleteModal()"
  (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal
  [open]="showRestoreModal"
  heading="Restore compliance lock?"
  [entityName]="restoreEntityName"
  activeListLabel="compliance locks list"
  [loading]="restoreLoading()"
  (cancelled)="closeRestoreModal()"
  (confirmed)="submitRestore()"
/>
